import type { WidgetInstance } from "./widget-types"

export const defaultLayout: WidgetInstance[] = [
  {
    id: "welcome-kpi-1",
    type: "welcomeKpi",
    span: 2,
    enabled: true,
    config: {},
  },
  {
    id: "quick-actions-1",
    type: "quickActions",
    span: 1,
    enabled: true,
    config: {},
  },
  {
    id: "task-status-1",
    type: "taskStatus",
    span: 1,
    enabled: true,
    config: {},
  },
  {
    id: "today-agenda-1",
    type: "todayAgenda",
    span: 1,
    enabled: true,
    config: {},
  },
  {
    id: "team-status-1",
    type: "teamStatus",
    span: 1,
    enabled: true,
    config: {},
  },
  {
    id: "notes-1",
    type: "notes",
    span: 1,
    enabled: true,
    config: {},
  },
]

const STORAGE_KEY = "hexa.dashboard.layout.v6"
const STALE_KEYS = ["hexa.dashboard.layout.v2", "hexa.dashboard.layout.v3", "hexa.dashboard.layout.v4", "hexa.dashboard.layout.v5"]

export function loadLayout(): WidgetInstance[] {
  if (typeof window === "undefined") return defaultLayout

  // Remove stale old-version layouts
  for (const key of STALE_KEYS) {
    try { localStorage.removeItem(key) } catch { /* ignore */ }
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      return JSON.parse(stored) as WidgetInstance[]
    }
  } catch (error) {
    console.error("Failed to load layout from localStorage:", error)
  }

  return defaultLayout
}

export function saveLayout(layout: WidgetInstance[]): void {
  if (typeof window === "undefined") return

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(layout))
  } catch (error) {
    console.error("Failed to save layout to localStorage:", error)
  }
}
